<abp-modal [(visible)]="openCheckoutModal" (disappear)="modalClose.emit(false)">
  <ng-template #abpHeader>
    <h3>
      {{ 'RegisterService::CheckoutAssets' | abpLocalization }}
    </h3>
  </ng-template>
  <ng-template #abpBody>
    <app-locations-with-search
      [readonly]="true"
      [selectedNode]="selectedLocation"
      [pinOrKeyringPassword]="pinOrKeyringPassword"
      (selectedNodeChange)="selectLocation($event)"
      [locationDefinition]="locationDefinition"
      [displayHeaders]="false"
      [withLookup]="true"
      [isGuest]="isGuest"
      [showTransferNotes]="!hasTransfer"
      [showSubAssetsNotes]="hasTransfer"
      [(subAssetsNotes)]="transferData.notes"
      [(transferNotes)]="notes"
    />
  </ng-template>
  <ng-template #abpFooter>
    <button type="button" class="btn btn-primary" (click)="checkout()" [disabled]="isBusy">
      {{ 'AbpUi::Apply' | abpLocalization }}
    </button>
    <button
      *abpPermission="'RegisterService.Assets.Return'"
      type="button"
      class="btn btn-outline-secondary"
      (click)="return()"
      [disabled]="!hasSecondaryId"
    >
      {{ 'AbpUi::Return' | abpLocalization }}
    </button>
    <button type="button" class="btn btn-secondary" abpClose>
      {{ 'AbpUi::Close' | abpLocalization }}
    </button>
  </ng-template>
</abp-modal>
